document.addEventListener("DOMContentLoaded", function () {

    /*==========================
        IMAGE GALLERY
    ==========================*/

    const mainImage = document.getElementById("zaMainImage");
    const thumbs = document.querySelectorAll(".za-thumb");

    thumbs.forEach(function (thumb) {

        thumb.addEventListener("click", function () {

            mainImage.src = this.dataset.image;

            thumbs.forEach(function (item) {
                item.classList.remove("active");
            });

            this.classList.add("active");

        });

    });




    /*==========================
        PRICE CALCULATION
    ==========================*/

    const variantInputs = document.querySelectorAll('input[name="id"]');

    const addonInputs = document.querySelectorAll(".za-addon-checkbox");

    const priceElement = document.querySelector(".za-price");

    const variantPrice = document.getElementById("zaVariantPrice");

    const totalPrice = document.getElementById("zaTotalPrice");

    const addonSummary = document.getElementById("zaAddonSummary");

    if (
    !mainImage ||
    !priceElement ||
    !variantPrice ||
    !totalPrice ||
    !addonSummary
) {
    return;
}



    function formatMoney(cents){

        return "$" + (cents/100).toFixed(2);

    }



    function calculateTotal(){

        let basePrice = 0;

        const selectedVariant = document.querySelector('input[name="id"]:checked');

        if(selectedVariant){

            basePrice = parseInt(selectedVariant.dataset.price);

        }

        let addonsTotal = 0;

        addonSummary.innerHTML = "";

        addonInputs.forEach(function(addon){

            if(addon.checked){

                const addonPrice = parseInt(addon.dataset.price);

                addonsTotal += addonPrice;

                addonSummary.innerHTML += `
                    <div>
                        <span>${addon.dataset.title}</span>
                        <span>${formatMoney(addonPrice)}</span>
                    </div>
                `;

            }

        });

        const total = basePrice + addonsTotal;

        priceElement.innerHTML = formatMoney(basePrice);

        variantPrice.innerHTML = formatMoney(basePrice);

        totalPrice.innerHTML = formatMoney(total);

    }



    variantInputs.forEach(function(input){

        input.addEventListener("change",calculateTotal);

    });



    addonInputs.forEach(function(input){

        input.addEventListener("change",calculateTotal);

    });



    calculateTotal();

});


/*==========================
    AJAX ADD TO CART
==========================*/

const bannerForm = document.getElementById("zaBannerForm");

if (bannerForm) {

    bannerForm.addEventListener("submit", async function (e) {

        e.preventDefault();

        const selectedVariant = document.querySelector('input[name="id"]:checked');

        if (!selectedVariant) {
            alert("Please select a size.");
            return;
        }




        const bundleId = (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID()
    : "bundle_" + Date.now();

const upload = document.getElementById("zaUpload");
const imageUrl = document.getElementById("zaReferenceImage");

if (upload.files.length > 0 && !imageUrl.value) {
    alert("Please wait while your image uploads.");
    return;
}




        try {

            /* -----------------------------
               STEP 1 : ADD MAIN PRODUCT
            ----------------------------- */

            const mainProduct = {
    id: Number(selectedVariant.value),
    quantity: 1,
    properties: {

        "_bundle_type": "parent",
        "_bundle_id": bundleId,

        "Event Theme": bannerForm.querySelector('[name="properties[Event Theme]"]').value,
        "Event Date": bannerForm.querySelector('[name="properties[Event Date]"]').value,
        "Banner Details": bannerForm.querySelector('[name="properties[Banner Details]"]').value,
        "Reference Image": document.getElementById("zaReferenceImage").value,
        "Color Preference": bannerForm.querySelector('[name="properties[Color Preference]"]').value

    }
};

            const mainResponse = await fetch("/cart/add.js", {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify(mainProduct)

            });

            if (!mainResponse.ok) {

                const error = await mainResponse.json();

                console.log(error);

                alert(error.description || error.message);

                return;

            }

            /* -----------------------------
               STEP 2 : ADD ADDONS
            ----------------------------- */

            const addonItems = [];

            document.querySelectorAll(".za-addon-checkbox:checked").forEach(function(addon){
        
                addonItems.push({

    id: Number(addon.dataset.variantId),

    quantity: 1,

    properties: {

        "_bundle_type": "child",

        "_bundle_parent": bundleId,

        "_addon_title": addon.dataset.title

    }

});

            });
           

            if(addonItems.length){

                const addonResponse = await fetch("/cart/add.js",{

                    method:"POST",

                    headers:{
                        "Content-Type":"application/json"
                    },

                    body:JSON.stringify({
                        items:addonItems
                    })

                });

                if(!addonResponse.ok){

                    const error = await addonResponse.json();

                    console.log(error);

                }

            }

            /* -----------------------------
               STEP 3 : REDIRECT
            ----------------------------- */

            window.location.href="/cart";

        }

        catch(error){

            console.error(error);

            alert(error.message);

        }

    });

}




document.addEventListener("DOMContentLoaded", () => {

    const upload = document.getElementById("zaUpload");

    if (!upload) return;

    const hidden = document.getElementById("zaReferenceImage");
    const status = document.querySelector(".za-upload-status");
    const preview = document.querySelector(".za-upload-preview");

    upload.addEventListener("change", async function () {

        const file = this.files[0];

        if (!file) return;

        status.textContent = "Uploading...";

        const formData = new FormData();

        formData.append("file", file);
        formData.append("upload_preset", "shopify_upload");

        try{

            const response = await fetch(
                "https://api.cloudinary.com/v1_1/bpclfpst/image/upload",
                {
                    method:"POST",
                    body:formData
                }
            );

            const data = await response.json();

            if(data.secure_url){

                hidden.value = data.secure_url;

                preview.innerHTML = `
                    <img src="${data.secure_url}" style="max-width:180px;border-radius:10px;">
                `;

                status.textContent = "Upload Complete ✔";

            }else{

                console.log(data);
alert(JSON.stringify(data));

            }

        }catch(error){

            console.error(error);
alert(error.message);

        }

    });

});